<template>
    <b-card class="card-points" title="Vos points">
      <div class="card-content">
      <PuSkeleton :loading="isLoading" :count="1" width='200px'>                
      <span class="icon">
        <font-awesome-icon :icon="['far', 'bags-shopping']" />
      </span>
        {{points}}
      </PuSkeleton>
      </div>
    </b-card>
</template>


<script>
import card from '../card/Card'
//
export default {
  name: "CardPoint",
  components:{ 
  },
  mixins: [card],
  props:{
    points:{
      type:String,
      default:'236',
    },
  },
  data(){
    return {
      isLoading:true,   
    }
  },
  methods : {
  },  
  mounted (){
  },
  created(){
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000)      
  }   
}
</script>